export default __webpack_public_path__ + "static/media/gls-fr.e8ae1216.svg";